/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const fetchRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'DXqic4vk3V0SpAXF4dgnDOje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchByAgentExecutionAndInstanceIdRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc',
  rpcName: 'fetchByAgentExecutionAndInstanceId',
  auth: 'app',
  fingerprint: 'r8VzI0h9Eh3CfkDFrFWcEuje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc',
  rpcName: 'save',
  auth: 'app',
  fingerprint: 'aZj2iHcLhFyOUe2e_r4Xmeje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dismissRpc = {
  serviceName: 'com.hubspot.page.content.generator.rpc.AgentGeneratedLandingPagesRpc',
  rpcName: 'dismiss',
  auth: 'app',
  fingerprint: 'm9Q92CNDlrqOUe2e_r4Xmeje-XKqNbz9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};